import { environment } from '../../environments/environment';

export class AppUrls {
  // -----------------------------------
  // Developer settings
  // -----------------------------------

  private static urlNGROK = 'https://roesberg.liveforms.ngrok.io/';
  //private static urlDEMO = 'https://livedokweb.roesberg.com:8400/';
  private static urlDEMO = 'https://liveformsweb.roesberg.com/';
  private static urlLOCALANGULAR = 'https://localhost:4200';
  private static urlLOCALAPI = 'https://localhost:7129/';

  // who delivers Angular in development
  public static readonly useLocalAngular = true; // true for local angular development server (most cases), false for remote server

  // who delivers backend in development
  public static readonly useDemoForDevelopmentAPI = false; // true for Roesberg Online Demo
  public static readonly useNGROKForDevelopmentAPI = true; // true for NGROK else localhost

  // -----------------------------------

  public static baseUrlAngular = AppUrls.getBaseUrlAngular();
  public static actionSilentRefresh = 'silent-refresh.html';

  public static baseUrlMvc = AppUrls.getBaseUrlMvc();
  private static normalizedBaseUrlMvc: string;

  public static urlApi = 'api/';

  public static urlAuth = 'authorization/';
  public static actionAuthPswChange = 'ChangePassword';
  public static actionAuthLogin = 'Authorize';
  public static actionAuthLogout = 'Logout';
  public static actionAuthToken = 'Token';
  public static actionAuthUserInfo = 'UserInfo';
  public static actionAuthSessionCheck = 'CheckSession';

  public static urlConnect = 'connect/';
  public static urlDocument = 'document';
  public static actionConnectRevocation = 'revocation';

  public static urlMessage = 'message';

  public static urlProjects = 'projects';

  public static urlOrders = 'orders';
  public static urlForms = 'forms';

  public static urlSettings = 'settings';
  public static urlTempImages = 'images/temp/';
  private static urlLogout = 'logout';
  public static urlCloseWindow = 'home/closewindow';

  public static getBaseUrlAngular(): string {
    // in production, we always use the origin of the current window
    if (environment.production) {
      return window.location.origin;
    }

    // in development, we could also use a remote angular server
    if (!this.useLocalAngular) {
      if (this.useDemoForDevelopmentAPI) {
        return this.urlDEMO;
      }
      if (this.useNGROKForDevelopmentAPI) {
        return this.urlNGROK;
      }
    }
    // local angular development server
    return this.urlLOCALANGULAR;
  }

  public static getBaseUrlMvc(): string {
    // in production, we always use the origin of the current window
    if (environment.production) {
      return window.location.origin + '/';
    }
    // for development, we can use remote server to deliver API
    if (this.useDemoForDevelopmentAPI) {
      return this.urlDEMO;
    }
    if (this.useNGROKForDevelopmentAPI) {
      return this.urlNGROK;
    }
    // local API development server
    return this.urlLOCALAPI;
  }

  public static getLogoutUrl(): string {
    return this.getBaseUrlMvc() + this.urlLogout;
  }

  public static getApiUrl(path: string, action: string | undefined = undefined): string {
    let result = this.baseUrlMvc + this.urlApi + path;
    if (action != undefined && action !== '') {
      result = result + '/' + action;
    }
    return result;
  }

  public static getAuthUrl(urlAction: string): string {
    return this.baseUrlMvc + this.urlAuth + urlAction;
  }

  public static getConnectUrl(urlAction: string): string {
    return this.baseUrlMvc + this.urlConnect + urlAction;
  }

  public static getImageUrl(image: string): string {
    return this.baseUrlMvc + this.urlTempImages + image;
  }

  public static getAssetsUrl(asset: string): string {
    return 'assets/' + asset;
  }

  private static normalizeUrl(url: string): string {
    return url
      .toLowerCase()
      .replace(/^https?:\/*/g, '')
      .replace(/\/+$/g, '');
  }

  public static domainMatchMvc(origin: string | undefined) {
    if (origin == undefined || origin === '') {
      return false;
    }

    if (!this.normalizedBaseUrlMvc) {
      this.normalizedBaseUrlMvc = this.normalizeUrl(this.baseUrlMvc);
    }

    const normalizedOrigin = this.normalizeUrl(origin);
    return normalizedOrigin === this.normalizedBaseUrlMvc;
  }
}
